import e from "./extends.mjs";
import i from "./generateUtilityClasses.mjs";
import l from "./inputBaseClasses.mjs";
import s from "./generateUtilityClass.mjs";
function a(t) {
  return s("MuiFilledInput", t);
}
const n = e({}, l, i("MuiFilledInput", ["root", "underline", "input"])), d = n;
export {
  d as default,
  a as getFilledInputUtilityClass
};
//# sourceMappingURL=filledInputClasses.mjs.map
